import { createContext, useContext, useMemo, PropsWithChildren } from 'react';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import type { RouterComponent } from 'studio5/types/router.types';
import { isPreviewing } from 'studio5/lib/routing';

const RouterContext = createContext<RouterComponent>({} as RouterComponent);

export default function RouterProvider({
  children,
}: PropsWithChildren<unknown>) {
  const Router = useMemo<RouterComponent>(
    () => (isPreviewing() ? HashRouter : BrowserRouter),
    []
  );

  return (
    <RouterContext.Provider value={Router}>{children}</RouterContext.Provider>
  );
}

export function useRouter() {
  return useContext(RouterContext);
}
